import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'slick-carousel/slick/slick.css';
import globalStyles from './globalStyles';
import { landingTheme } from './theme';
import Landing from './pages/Landing';
import CookiePolicyBar from './components/CookiePolicyBar';

const GlobalStyle = createGlobalStyle`
  ${normalize()};
  ${globalStyles};
`;

const App = ({ cookiePolicySSR }) => (
  <ThemeProvider theme={landingTheme}>
    <div>
      <GlobalStyle />
      <ToastContainer hideProgressBar />
      <CookiePolicyBar cookiePolicySSR={cookiePolicySSR} />
      <Landing />
    </div>
  </ThemeProvider>
);

export default App;
